export const createMetroApiConfig = (metroService, options) => {
  const service = {
    ...(options == null ? void 0 : options.serviceOptions),
    baseUrl: '/'
  };
  return Object.keys(metroService).reduce((acc, methodName) => {
    var _options$methodsOptio, _options$methodsOptio2;
    const {
      httpOptions: httpOptionsFn,
      ...methodOptions
    } = (_options$methodsOptio = options == null ? void 0 : (_options$methodsOptio2 = options.methodsOptions) == null ? void 0 : _options$methodsOptio2[methodName]) != null ? _options$methodsOptio : {};
    return {
      ...acc,
      [methodName]: {
        ...methodOptions,
        name: methodName,
        service,
        queryFn: async _ref => {
          let {
            httpClient,
            request
          } = _ref;
          const httpOptions = httpOptionsFn == null ? void 0 : httpOptionsFn(request);
          const response = await httpClient.request(requestFactory(httpOptions, metroService[methodName](request)));
          return response.data;
        }
      }
    };
  }, {});
};
const requestFactory = (httpOptions, metroRequestOrFactory) => {
  if (!httpOptions) {
    return metroRequestOrFactory;
  }
  return context => {
    const options = typeof metroRequestOrFactory === 'function' ? metroRequestOrFactory(context) : metroRequestOrFactory;
    return {
      ...options,
      ...httpOptions,
      headers: {
        ...options.headers,
        ...(httpOptions == null ? void 0 : httpOptions.headers)
      }
    };
  };
};
//# sourceMappingURL=createMetroApiConfig.js.map